import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/userContext';
import axiosClient from '../api/AxiosConfig';
import { ROLE } from '../Services/auth.service';

export default function useAuth() {
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);
  const [error, setError] = useState(null);

  // set user
  const setUserContext = async () =>
    axiosClient
      .get('/get-me')
      .then((res) => {
        setUser(res.data);
        console.log(res.data);
        switch (res.data.role) {
          case ROLE.Admin:
            navigate('/booking', { replace: true });
            break;
          case ROLE.Root:
            navigate('/booking', { replace: true });
            break;
          case ROLE.CSKH:
            navigate('/customer', { replace: true });
            break;
          case ROLE.Employee:
            navigate('/promotion', { replace: true });
            break;
          case ROLE.Manager:
            navigate('/booking', { replace: true });
            break;
          case ROLE.Recruit:
            navigate('/recruit', { replace: true });
            break;

          default:
            break;
        }
      })
      .catch((err) => {
        setError(err.response.data);
      });

  // login user
  const loginUser = async (data) => {
    const { username, password } = data;
    return new Promise((resolve, reject) => {
      axiosClient
        .post('/login', {
          username,
          password,
        })
        .then(async (res) => {
          await setUserContext();
          resolve(res);
        })
        .catch((err) => {
          reject(err.response.data);
        });
    });
  };

  // Logout User
  const logoutUser = async () => {
    return axiosClient
      .post('/logout')
      .then(async () => {
        await setUser(null);
        navigate('/login', { replace: true });
      })
      .catch((err) => {
        setError(err.response.data);
      });
  };

  return {
    loginUser,
    logoutUser,
    error,
  };
}
